import { TimelineModel } from './timeline.model';
import { CameraModel } from '../../engine/models/camera.model';
import { LabelModel } from './labels/label.model';
import { Type, Exclude, Expose, plainToClass } from 'class-transformer';
import { SynchronizationModel } from './synchronization.model';
import { ChapterGraphModel } from './chapter-graph.model';
import { HotspotModel } from './labels/hotspot.model';
import { BackgroundModel } from 'src/app/engine/models/background.model';
import { MediaModel } from './media.model';

/* The Chapter model as it pertains to the application The engine is responsible
for building animation timelines and sychronizing the state of the scene-graph
at the start of each chapter. This data is stored in the Human Engine's chapter
object.

Engine responsibilities for faithfully setting chapter state include 1 - graph
synchronization. the state of each object in the scene-graph 2 - clipping
planes. These must be in effect simultaneously with the graph synchronization,
or else flashing may occur. 3 - camera position and action. 4 - lights.

Engine responsibilities for building chapter 1- building of the animations and
the corresponding timeline maps to map chapter time to animation time

However, the engine's chapter object stores several data attributes that it need
not be responsible for managing. Examples include: 1 - background color 2 - meta
data, display name and description 3 - labels (however, they do contain
engine-specific data for tracking points in space via markers) 4 - customData -
special, protected location scoped on the chapter for custom or in-development
features.

NOTE: EXCLUDE/EXPOSE
The human chapter object contains many properties that we do not want exposed to the application.
We use @Exclude/@Expose decorators to insist that only the @Expose'd properties are passed to the application state.

*/


@Exclude()
export class ChapterModel {
    // Define nested types --------------------------------------------------
    @Type(() => LabelModel)
    @Type(() => SynchronizationModel)
    @Type(() => CameraModel)
    @Type(() => ChapterGraphModel)

    // Shared Data between Human Chapter and App Chapter ---------------------
    @Expose()
    id: string;

    @Expose()
    info: {
        displayName: string,
        description: string,
    };

    @Expose()
    labels: LabelModel[];

    @Expose()
    hotspots?: HotspotModel[];

    @Expose()
    synchronization: SynchronizationModel;

    @Expose()
    background: BackgroundModel;
    
    @Expose()
    lights: any;

    @Expose()
    timelineMap: TimelineModel[];

    @Expose()
    camera: {
        action: 'jumpTo' | 'flyTo',
        location: CameraModel
    };

    @Expose()
    properties: {
        [key: string]: string;
    };

    @Expose()
    loop: boolean;

    @Expose()
    customData: any;

    @Expose()
    clippingPlanes: any;

    @Expose()
    ui: any;

    @Expose()
    graph: ChapterGraphModel;

    @Expose()
    viewModes: any;

    @Expose()
    recipes: any;

    @Expose()
    transparencyMode: string;

    @Expose()
    fallbackTransparency: any;

    @Expose()
    effects: any;

    @Expose()
    environment: any;

    @Expose()
    options: any;

    @Expose()
    media: {
        [key: string]: MediaModel;
    };

    // new data not in human chapter
    readyState: {
        model: boolean;
        animation: boolean;
    };
}
